import { render } from "./StatsActionRenderer.vue?vue&type=template&id=5bae1a7a&scoped=true"
import script from "./StatsActionRenderer.vue?vue&type=script&lang=ts"
export * from "./StatsActionRenderer.vue?vue&type=script&lang=ts"

import "./StatsActionRenderer.vue?vue&type=style&index=0&id=5bae1a7a&lang=css&scoped=true"
import "./StatsActionRenderer.vue?vue&type=style&index=1&id=5bae1a7a&lang=scss"
script.render = render
script.__scopeId = "data-v-5bae1a7a"

export default script